import { useCallback } from "react";
import { useTeleconsultoriaProfile } from "../profile/TeleconsultoriaProfileContext";
import {
  appendTeleconsultoriaAppointments,
  type TeleconsultoriaAppointmentsQuery,
} from "../services/teleconsultoriaAppointmentsService";

type AppendTeleconsultorias = <T extends fhir5.Bundle | undefined>(
  bundle: T,
  query: TeleconsultoriaAppointmentsQuery,
) => Promise<T>;

/**
 * Para o dashboard da AFILIADA: a teleconsultoria fica na Location/agenda da
 * prestadora, então as buscas do dashboard (por Location/agenda da própria
 * clínica) não a encontram. Este hook soma essas consultas ao bundle.
 * Prestadora e "nenhum": devolve o bundle sem chamada extra.
 * `teleconsultoriaProfileKind` entra nas dependências do efeito do dashboard
 * (o perfil pode chegar depois da primeira busca).
 */
export function useTeleconsultoriaDashboardAppender() {
  const { profile } = useTeleconsultoriaProfile();
  const isAffiliate = profile.kind === "affiliate";

  const appendTeleconsultorias = useCallback<AppendTeleconsultorias>(
    (bundle, query) =>
      isAffiliate ? appendTeleconsultoriaAppointments(bundle, query) : Promise.resolve(bundle),
    [isAffiliate],
  );

  return { appendTeleconsultorias, teleconsultoriaProfileKind: profile.kind };
}
